import { Slider, ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({
	components: {
		MuiSlider: {
			styleOverrides: {
				root: {
					width: "100%",
					height: "8px",
					padding: "0 !important",
					"& .MuiSlider-thumb": {
						display: "none",
					},
					"& .MuiSlider-track": {
						background: "linear-gradient(270deg, #009AC0 0%, #0072CE 100%)",
						border: "none",
						height: 8,
					},
					"& .MuiSlider-rail": {
						background: "#F4F4F5",
						height: 8,
						opacity: 1,
					},
				},
			},
		},
	},
});

type Props = {
	min: number;
	max: number;
	step: number;
	value: number;
	onChange?: (event: Event, value: number | number[]) => void;
	disabled?: boolean;
	sx?: any;
};

const ProgressBar: React.FC<Props> = ({
	min,
	max,
	step,
	value,
	onChange,
	disabled,
	sx,
}) => {
	return (
		<ThemeProvider theme={theme}>
			<Slider
				min={min}
				max={max}
				step={step}
				value={value}
				onChange={onChange}
				disabled={disabled}
				sx={sx}
			/>
		</ThemeProvider>
	);
};

export default ProgressBar;
